var map = {
	"./boots/overall/orange.jpg": "15e8",
	"./gloves/overall/orange.jpg": "6869",
	"./jackets/back/orange.jpg": "9d64",
	"./jackets/chest/orange.jpg": "1a27",
	"./jackets/elbow/orange.jpg": "b2fa",
	"./jackets/shoulder/orange.jpg": "50f5",
	"./pants/hip/orange.jpg": "01e2",
	"./pants/knee/orange.jpg": "ada9",
	"./pants/tailbone/orange.jpg": "05fe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ccf1";